// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loni-checkbox-group[data-v-cbd93c08]{display:flex;width:100%}.loni-checkbox-group.vertical[data-v-cbd93c08]{flex-direction:column}", ""]);
// Exports
module.exports = exports;
